import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-multi-station-settings",
	templateUrl: "./multi-station-settings.component.html",
	styleUrls: ["./multi-station-settings.component.css"],
})
export class MultiStationSettingsComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	SettingsOption: string = "District";

	/////////////////////////////////////////////////////////////////
}
